var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.stats),function(stat,index){return _c('div',{key:index,staticClass:"faded_border_bottom"},[_c('p',[_vm._v(_vm._s(_vm.time_helper.convertDecimalHoursToTime(stat.effort_time)))]),(stat.resources)?_c('stat-resources',{attrs:{"payload":{ stat, show_details: true }}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }